import initialState from '@/core/store/initialState';
import { isObj, isArr, isNull } from '@/core/utils';

/**
* @description Is valid
* @param authors
* @returns {boolean}
*/
const isValid = (authors) => isObj(authors)
  && isNull(authors.filters)
  && isArr(authors.items)
  && isNull(authors.size)
  && isObj(authors.activeItem);

/**
* @description Init state
* @param initialState
* @returns {*}
*/
const initState = (initialState) => {
  if (!isValid(initialState)) {
    throw Error('Invalid initial stories authors state');
  }

  const { items, size, activeItem, filters } = initialState;
  return {
    items,
    size,
    activeItem,
    filters,
  };
};

/**
* @description Getters
* @type {*}
*/
export const getters = {
  items: ({ items }) => items,
  size: ({ size }) => size,
  activeItem: ({ activeItem }) => activeItem,
  filters: ({ filters }) => filters,
};

const actions = {
  setFilters: ({ commit }, nextFilters) => {
    commit('FILTER', nextFilters);
  },
  reset: ({ commit }) => (
    commit('SET', initialState.storiesAuthors)
  ),
  set: ({ commit }, authors) => {
    commit('SET', authors);
  },
};

const mutations = {
  SET(state, authors) {
    state.items = authors.items;
    state.size = authors.size;
    state.activeItem = authors.activeItem;
    state.filters = authors.filters;
  },
  FILTER(state, filters) {
    state.filters = filters;
  },
};

export default initialState => ({
  namespaced: true,
  state: initState(initialState),
  getters,
  actions,
  mutations,
});
